// CustomerListFooter.js
import React from 'react';

import './IndexPagination.css';

export default function ListFooter(props) {
  return <div className="ListFooter">{props.children}</div>;
}
